// -*-mode: rjsx -*-
// REACT
import React, { Component } from "react"
import PropTypes from "prop-types"
// eslint-disable-next-line
import clsx from "clsx"

// ROUTER
// eslint-disable-next-line
import { Link, Redirect } from "react-router-dom"

// MUI
// eslint-disable-next-line
import { makeStyles, withStyles } from "@material-ui/core/styles"
import CssBaseline from "@material-ui/core/CssBaseline"
import Typography from "@material-ui/core/Typography"
import RightIcon from "@material-ui/icons/ArrowRightAlt"
import ForwardIcon from '@material-ui/icons/ArrowForwardIos';

import grey from "@material-ui/core/colors/grey"


// FLASH
//import FlashLogo from "../static/images/lightning-logo-transparent.png"
import FlashLogo from "../static/images/pulseai/pulseai.logo3.transparent.png"

const styles = theme => ({


    fabDiv: {
        // position: "relative",
        // bottom: 50,
        // paddingRight: 20,
        display: "flex",
        justifyContent: "flex-end",
    },
    
    fab: {
        position: "fixed",
        //        bottom: theme.spacing(8),
        //        bottom: "5%",
        //        right: theme.spacing(1),
        //        left: "75%",
        // marginLeft: 400,
        //        marginLeft: "65%",
        //        marginTop: "-20%",
        zIndex: 10,

        width: 60,
        height: 60,


        //
        // mobile
        //
        [theme.breakpoints.down("md")]: {
            // marginTop: "-10%",
            bottom: "5%",
            right: "8%",
        },

        
        //
        // desktop
        //
        [theme.breakpoints.up("md")]: {
            //            left: "60%",
            //            bottom: "20%",
            //            marginLeft: 400,
            //            marginLeft: "25%",
            //            marginTop: "0%",
        },

    },
    
    fabBlue: {
        color: theme.palette.common.white,
        //backgroundColor: theme.palette.custom.scrollDark,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.primary.light,
        },
    },
    
    //
    // proper styles
    //

    "@keyframes loginAnimation":  {
        "0%": {
            opacity: 1,
        },

        "40%": {
            opacity: 1,
        },
        
        "99%": {
            opacity: 0,
            width: "100%",
            height: "100%",
        },

        "100%": {
            opacity: 0,
            width: 0,
            height: 0,
        }
    },

    
    logoRoot: {
        position: "fixed",
        top: 0,
        left: 0,
        
        display: "flex",
        alignItems: "center", // vertical center
        justifyContent: "center", // horizontal center

        width: "100%",
        height: "100%",
        background: theme.palette.primary.main,
        zIndex: 1000,

        animationName: "$loginAnimation",
        animationDuration: "4s",
        animationFillMode: "forwards",

        userSelect: "none",
        
    },

    logoImg: {

        width: "40%",
        maxWidth: 200,

        //
        // desktop
        //
        [theme.breakpoints.up("md")]: {
            // marginTop: -350,
            // marginTop: "-15%",
        },
        
    },

    // text page
    // here instead of intro we want to scroll
    // so position is not fixed
    introRoot: {
        //        position: "fixed",
        //        top: 0,
        //        left: 0,
        
        display: "flex",
        flexDirection: "column",
        alignItems: "center", // vertical center
        justifyContent: "center", // horizontal center

        width: "100%",
        height: "100%",

        backgroundColor: "#FFFFFF",

        userSelect: "none",
        
    },

    introText: {
        //  margin: "auto",
        //marginTop: "5%",
        //
        // desktop - if more than 600
        //
        marginTop: "3em",
        [theme.breakpoints.up("md")]: {
            marginTop: "6em",
        },
        paddingLeft: 40,
        paddingRight: 40,
        maxWidth: 600,
        backgroundColor: "#FFFFFF",
        zIndex: 1000
    },

    titleText: {
        color: theme.palette.primary.main,
        fontSize: 24,
    },

    titleLogo: {
        marginRight: 5,
        marginBottom: 10,
        // paddingBottom: 10,
        //        marginTop: "18%",
        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            marginBottom: -10,
        },

        //        height: 62,
        //        width: 62,

        // height: 72,
        // width: 144,

        height: 108,
        width: 216,
        
    },

    forwardArrow: {
        marginTop: -20,        
        width: 120,
        height: 120,
        color: theme.palette.primary.main,

        //
        // desktop
        //
        [theme.breakpoints.up("md")]: {
            marginTop: -72,
            marginLeft: -230,        
        },
    },

    policyDiv: {
//        marginTop: -8,
//        marginLeft: 20,
        //        marginRight: 20,
        marginLeft: -100
    },

    //
    // REGISTER STYLES
    //
    
    continueText: {
        marginBottom: "0px",
        marginRight: "18px",
        color: theme.palette.primary.main,
        fontSize: "16px",
        fontWeight: "700"
    },


    forwardButton: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        //justifyItems: "flex-center",
        width: "51px",
        height: "51px",
        borderRadius: "50%",
        backgroundColor: theme.palette.primary.main,
        boxShadow: "0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12)",
        "&:hover": {
            backgroundColor: "#438cffc2"
        }
    },

    forwardArrow: {
        //marginTop: -20,        
        //width: "25",
        //height: "25",
        fontSize: "28px",
        color: "white",
        marginLeft: "4px",
        //
        // desktop
        //
        [theme.breakpoints.up("md")]: {
//            marginTop: -72,
//            marginLeft: -230,        
        },
    }

    
    
})

let TouComponent = withStyles(styles, { name: "TouComponent" })(
    class TouComponentBasis extends Component {

        // yes, we can redirect from children!

        state = {
            redirectToRegister: false,
            debugLayout: false
        }

        handleStartClick = () => {
            console.log("<Tou>: handleStartClick()")
            const { history, registerUrl } = this.props
            console.log("<Intro>: handleStartClick(): history =", history)
            history.push(registerUrl)
            //this.setState({redirectToRegister: true})
        }
        
        render() {

            const { classes, match, history } = this.props;

            let registerUrl = "/register"; // default
            if(match) {
                const { driveSlug } = match.params;
                if(driveSlug) {
                    registerUrl = `/drives/${driveSlug}/register`;
                }
            }

            /*
            // redirects first
            if (this.state.redirectToRegister) {
                return <Redirect push to="/register"/>
            }
            */
            
            return(
                <div className={classes.introRoot}>
                  <div className={classes.introText}>
                    <div style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        backgroundColor: this.state.debugLayout ? grey[800] : "inherit",
                    }}>
                    <div className={classes.titleLogo} style={{
                        backgroundColor: this.state.debugLayout ? grey[800] : "inherit",
                    }}
                    >
                      <img alt="logo" src={FlashLogo} style={{width: "100%"}}/>
                    </div>
                    </div>
                    <div> 
                      <div className={classes.titleText}><b>Terms of Use</b></div>
                    </div>
                    <div style={{marginTop: 10}}/>
                    <Typography variant="body1">
                      <b>Welcome To PulseAI!</b>
                    </Typography>


                    <div style={{marginTop: 10}}/>
                    <Typography style={{fontSize: "0.9em"}} variant="body1">
                      <b>These Terms of Use govern your use of PulseAI and provide information about the
                      product. When you create a PulseAI account or use PulseAI, you agree to these
                      terms.</b>
                    </Typography>

                    <div style={{marginTop: 10}}/>
                    <Typography style={{fontSize: "0.9em"}} variant="body1">
                      <b>The PulseAI product is one of the PulseAI products, provided to you by
PulseAI, Inc. These Terms of Use therefore constitute an agreement
between you and PulseAI, Inc.</b>
                    </Typography>


                    <div style={{marginTop: 10}}/>
                    <Typography variant="body1">
                      We agree to provide you with use of the PulseAI platform to give you a better voice for to your elected
                      representatives and to foster a more representative democracy.
                    </Typography>


                    <div style={{marginTop: 10}}/>
                    <Typography style={{fontSize: 17}} variant="body1">
                      <b>Our Data Policy</b>
                    </Typography>

                    <div style={{marginTop: 10}}/>
                    <Typography variant="body1">
                      Providing our Service requires collecting and using your information in two areas: a) your volunteered
                      commentary and b) your name, zip code and email address. Your volunteered commentary is aggregated
                      with those of other users, as data, by topic and demography, and delivered to elected representatives
                      whom you choose to address. Your name and ID are used to validate and ensure you are a real person
                      currently living in your zip code. We do not retain any data regarding your name of location within our
                      files; only representatives whom you choose to address will have such data. Your use of PulseAI
                      constitutes an agreement to our Data Policy.
                    </Typography>

                    <div style={{marginTop: 10}}/>
                    <Typography style={{fontSize: 17}} variant="body1">
                      <b>Your Commitments</b>
                    </Typography>

                    <div style={{marginTop: 10}}/>
                    <Typography variant="body1">
                      In return for our commitment to provide the Service, we require you to make the below commitments to
us.
                    </Typography>


                    <div style={{marginTop: 10}}/>
                    <Typography style={{fontSize: 15}} variant="body1">
                      <b>Who Can Use PulseAI</b>
                    </Typography>

                    <div style={{marginTop: 10}}/>
                    <Typography variant="body1">
                      We want our Service to be valued by our elected representatives and therefor
ask that all users be at least 18 years of age.
                    </Typography>

                    <div style={{marginTop: 10}}/>
                    <Typography style={{fontSize: 15}} variant="body1">
                      <b>How You Can't Use PulseAI</b>
                    </Typography>

                    <div style={{marginTop: 10}}/>
                    <Typography variant="body1">
                      &nbsp;&nbsp;&bull;&nbsp;&nbsp;You can't impersonate others or provide inaccurate information.
                    </Typography>

                    <div style={{marginTop: 10}}/>
                    <Typography variant="body1">
                      &nbsp;&nbsp;&bull;&nbsp;&nbsp;You can't violate (or help or encourage others to violate) these Terms or our policies.
                    </Typography>

                    <div style={{marginTop: 10}}/>
                    <Typography variant="body1">
                      &nbsp;&nbsp;&bull;&nbsp;&nbsp;You can't do anything to interfere with or impair the intended operation of the Service.
                    </Typography>

                    <div style={{marginTop: 10}}/>
                    <Typography variant="body1">
                      &nbsp;&nbsp;&bull;&nbsp;&nbsp;You can't attempt to buy, sell, or transfer any aspect of your account (including your username) or solicit, collect, or use login credentials of other users.
                    </Typography>
                    

                    <div style={{marginTop: 10}}/>
                    <Typography style={{fontSize: 17}} variant="body1">
                      <b>Rights We Retain</b>
                    </Typography>

                    <div style={{marginTop: 10}}/>
                    <Typography variant="body1">
                      &nbsp;&nbsp;&bull;&nbsp;&nbsp;We retain all rights to intellectual property used in PulseAI. There are no exceptions.
                    </Typography>


                    <div style={{marginTop: 10}}/>
                    <Typography variant="body1">
                      &nbsp;&nbsp;&bull;&nbsp;&nbsp;We retain the right to disable or terminate your account should you violate the terms of use.
                    </Typography>
                    

                    <div style={{marginTop: 10}}/>
                    <Typography style={{fontSize: 15}} variant="body1">
                      <b>Who Has Rights Under This Agreement</b>
                    </Typography>

                    <div style={{marginTop: 10}}/>
                    <Typography variant="body1">
                      &nbsp;&nbsp;&bull;&nbsp;&nbsp;This agreement does not give rights to any third parties.
                    </Typography>

                    <div style={{marginTop: 10}}/>
                    <Typography variant="body1">
                      &nbsp;&nbsp;&bull;&nbsp;&nbsp;You cannot transfer your rights or obligations under this agreement without our consent.
                    </Typography>


                    <div style={{marginTop: 10}}/>
                    <Typography variant="body1">
                      &nbsp;&nbsp;&bull;&nbsp;&nbsp;Our rights and obligations can be assigned to others. For example, this could occur if our ownership changes (as in a merger, acquisition, or sale of assets) or by law.
                    </Typography>

                               
                    <div style={{marginTop: 10}}/>
                    <Typography style={{fontSize: 15}} variant="body1">
                      <b>Who Is Responsible If Something Happens</b>
                    </Typography>

                    <div style={{marginTop: 10}}/>
                    <Typography variant="body1">
                      &nbsp;&nbsp;&bull;&nbsp;&nbsp;Our Service is provided &quot;as is,&quot; and we can&#39;t guarantee it will be safe and secure or will work perfectly all the time. TO THE EXTENT PERMITTED BY LAW, WE ALSO
DISCLAIM ALL WARRANTIES, WHETHER EXPRESS OR IMPLIED, INCLUDING
THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
PARTICULAR PURPOSE, TITLE, AND NON-INFRINGEMENT.
                    </Typography>


                    <div style={{marginTop: 10}}/>
                    <Typography variant="body1">
                      &nbsp;&nbsp;&bull;&nbsp;&nbsp;We also don’t control what people and others do or say, and we aren’t responsible for their (or your) actions or conduct (whether online or offline) or content (including unlawful or
objectionable content).
                    </Typography>


                    <div style={{marginTop: 10}}/>
                    <Typography style={{fontSize: 15}} variant="body1">
                      <b>Unsolicited Material</b>
                    </Typography>

                    <div style={{marginTop: 10}}/>
                    <Typography variant="body1">
                      &nbsp;&nbsp;&bull;&nbsp;&nbsp;We always appreciate feedback or other suggestions, and may use them without any restrictions or obligation to compensate you for them, and are under no obligation to keep them confidential.
                    </Typography>


                    <div style={{marginTop: 10}}/>
                    <Typography style={{fontSize: 17}} variant="body1">
                      <b>Updating These Terms</b>
                    </Typography>
                    
                    <div style={{marginTop: 10}}/>
                    <Typography variant="body1">
                      We may change our Service and policies, and we may need to make changes to these Terms so that they
                      accurately reflect our Service and policies. Unless otherwise required by law, we will notify you (for
                      example, through our Service or via email) before we make changes to these Terms and give you an
                      opportunity to review them before they go into effect. You have the opportunity to delete your account at
                      any time.
                    </Typography>
                  </div>


                  <div style={{marginTop: "4em", marginBottom: "4em"}}>
                    <span onClick={this.handleStartClick}
                          style={{ cursor: "pointer" }}>
                      <div style={{
                          backgroundColor: this.state.debugLayout ? grey[800] : "inherit",
                          display: "flex",
                          flexDirection: "row",
                          flexWrap: "wrap",
                          //justifyContent: "space-between",
                          justifyContent: "center",
                          alignItems: "center",
                          marginRight: "auto"
                      }}>
                        <div className={classes.continueText}>REGISTER</div>
                        <div className={classes.forwardButton}>
                          <ForwardIcon className={classes.forwardArrow}/>
                        </div>                
                      </div>
                    </span>
                  </div>
                </div>
            )
        }
    }
)

class Tou extends Component {

    render() {
        
        const { match, history } = this.props
        let registerUrl = "/register" // default
        if(match) {
            const { driveSlug } = match.params
            if(driveSlug) {
                registerUrl = `/drives/${driveSlug}/register`
            }
        }

	return(
            <React.Fragment>
	      <CssBaseline/>
              <TouComponent history={history} registerUrl={registerUrl}/>
            </React.Fragment>
	)
    }
}

Tou.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withStyles(styles, { name: "Tou" })(Tou)

